import { useEffect } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/lib/auth-context';
import {
  isAllowedExternalRedirect,
  rememberAuthRedirect,
  resolveAuthRedirect,
} from '@/lib/auth-redirect';
import { userNeedsSubscription, defaultHomePathForUser } from '@/lib/plan-access';

export default function GuestOnlyRoute({ children }) {
  const { user, loading } = useAuth();
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get('redirect');
  const externalReturn = isAllowedExternalRedirect(resolveAuthRedirect(redirect));

  useEffect(() => {
    if (redirect) {
      rememberAuthRedirect(redirect);
    }
  }, [redirect]);

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="animate-pulse text-muted-foreground">Loading...</div>
      </div>
    );
  }

  if (user && externalReturn) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <p className="text-muted-foreground">Returning to Protego…</p>
      </div>
    );
  }

  if (user) {
    if (userNeedsSubscription(user)) {
      return <Navigate to="/settings#plans" replace />;
    }
    return <Navigate to={defaultHomePathForUser(user)} replace />;
  }

  return children;
}
